<div class="pt-4 py-4" *ngIf="!formSubmitted">
  <div class="container">
    <h3>Questionnaire de satisfaction</h3>
  </div>
</div>
<div class="pt-4 py-4">
  <div class="container satisfaction">
    <div *ngIf="!formSubmitted">
      <p>Merci d’avoir fait confiance à <span class="fw-bold">THE DOOR MAN</span> pour la réalisation de votre projet
        immobilier.
        <br/>Votre avis nous est précieux pour améliorer la qualité de notre accompagnement.
        <br/>Ce questionnaire ne vous prendra que <span class="fw-bold">2 minutes</span>.</p>
      <form *ngIf="formSatisfaction"  [formGroup]="formSatisfaction" (ngSubmit)="onSubmit()" class="form-satisfaction">
        <!-- Accompagnement -->
        <div class="question">
          <span class="question-title">1. Comment évalueriez-vous la qualité de l’accompagnement reçu ?</span><br>
          <div class="star-rating">
            <ng-container *ngFor="let a of accompagnements">
              <input type="radio" [value]="a.value " formControlName="accompagnement" id="accompagnement-{{a.value }}">
              <label for="accompagnement-{{a.value }}" class="star">&#9733;</label>
            </ng-container>
          </div>
          (1 = très insatisfait / 5 = très satisfait)
          <div *ngIf="formSatisfaction.get('accompagnement')?.invalid && formSatisfaction.get('accompagnement')?.touched"
               class="error">
            Veuillez sélectionner un niveau d’accompagnement.
          </div>
        </div>
        <!-- Attente -->
        <div class="question">
          <span class="question-title">2. Le Conseiller en immobilier THE DOOR MAN a-t-il répondu à vos attentes ?</span><br>
          <div *ngFor="let att of attentes">
            <input type="radio" [value]="att.value " formControlName="attente" id="attente-{{att.value }}">
            <label for="attente-{{att.value }}">{{ att.label }}</label>
          </div>
          <div *ngIf="formSatisfaction.get('attente')?.invalid && formSatisfaction.get('attente')?.touched"
               style="color:red;">
            Veuillez sélectionner votre niveau d'attente.
          </div>
        </div>
        <!-- Communication -->
        <div class="question">
          <span class="question-title">3. La communication avec votre conseiller a-t-elle été claire, réactive et professionnelle
            ?</span><br>
          <div *ngFor="let c of communications">
            <input type="radio" [value]="c.value " formControlName="communication" id="communication-{{c.value }}">
            <label for="communication-{{c.value }}">{{ c.label }}</label>
          </div>
          <div *ngIf="formSatisfaction.get('communication')?.invalid && formSatisfaction.get('communication')?.touched"
               style="color:red;">
            Veuillez sélectionner votre avis sur la communication.
          </div>
        </div>
        <!-- Recommandation -->
        <div class="question">
          <span class="question-title">4. Recommanderiez-vous THE DOOR MAN à votre entourage ?</span><br>
          <div *ngFor="let r of recommandations">
            <input type="radio" [value]="r.value " formControlName="recommandation" id="recommandation-{{r.value }}">
            <label for="recommandation-{{r.value }}">{{ r.label }}</label>
          </div>
          <div
            *ngIf="formSatisfaction.get('recommandation')?.invalid && formSatisfaction.get('recommandation')?.touched"
            style="color:red;">
            Veuillez sélectionner votre recommandation.
          </div>
        </div>
        <!-- Commentaire -->
        <div class="question">
          <label for="commentaire">5. Souhaitez-vous partager un commentaire ou une suggestion ?:</label><br>
          <textarea id="commentaire" formControlName="commentaire" rows="4" cols="50"></textarea>
        </div>
        <!-- Bouton submit -->
        <div style="margin-top:15px;">
          <button type="submit" class="btn btn-gold">Envoyer</button>
        </div>
      </form>
    </div>
    <div *ngIf="formSubmitted">
      <h2>Merci pour votre confiance 🤝</h2>
      <p>Votre retour contribue directement à renforcer la qualité de notre accompagnement au sein du réseau THE DOOR
        MAN.</p>
    </div>
  </div>
</div>

